import React, { createContext, useContext, useEffect, useState } from 'react';

const PricingContext = createContext();

export const usePricing = () => useContext(PricingContext);

// Live prices/discounts come from the backend (the only trusted source - it's
// also what actually gets charged at checkout). The static catalog in
// servicesData.js still owns everything else (images, descriptions, etc).
export const PricingProvider = ({ children }) => {
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/services/prices`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setPrices(data.prices);
      })
      .catch((err) => console.error('Failed to load live prices:', err))
      .finally(() => setLoading(false));
  }, []);

  const getPricedService = (service) => {
    const live = prices[service.id];
    if (!live) {
      // Prices haven't loaded yet (or this id has no live entry) - fall back to
      // the static catalog price so the page still renders something sensible.
      return { ...service, originalPrice: service.price, discountPercent: 0 };
    }
    const discountPercent = live.discountPercent || 0;
    const finalPrice = discountPercent > 0
      ? Math.round(live.price * (1 - discountPercent / 100) * 100) / 100
      : live.price;

    return {
      ...service,
      price: finalPrice,
      originalPrice: live.price,
      discountPercent,
    };
  };

  return (
    <PricingContext.Provider value={{ prices, loading, getPricedService }}>
      {children}
    </PricingContext.Provider>
  );
};
